import { EnvironmentFormRequest } from "./environment-form-request.interface";

export class SelfBuyForm {
    constructor() {
        this.environments = [];
        this.enabled24x7 = false;
        this.enabledSupport = true;
    }
    subscriptionId: string;
    environments: EnvironmentFormRequest[];
    enabled24x7: boolean;
    enabledSupport: boolean;
}